import React from 'react';

import {withRouter} from 'react-router-dom';
import makeover from '../assets/images/make_over/cover.JPG';
import wedding from '../assets/images/wedding_engage/2.JPG';
import makeup from '../assets/images/makeup_hair/cover.jpg';

 class Work extends React.Component{
    
    

     Onclick(e)
    {
        e.preventDefault();
        this.props.history.push('/wedding');
    }

    onWeddingClick(e)
    {
        this.props.history.push('/wedding');
    }
    onMakeoverClick(e)
    {
        this.props.history.push('/makeover');
    }
    onMakehairClick(e)
    {
        this.props.history.push('/makehair');
    }

   render(){
    //function importAll(r) {
       // let images = {};
        //r.keys().map((item, index) => { images[index] = r(item); });
       // return images;
    //}
    //let contex = require.context('../assets/images/wedding', false, /\.(png|jpe?g|svg)$/);
    //const images = importAll(contex);
   // const images = importAll(require.context('../assets/images/wedding', false, '/\.png/'));
   // const cardList = workDataArray.map((item, index) =>{
       // return(
            //<Card title={item.name} info={item.info} src={item.img} key={index} alt={item.alt} code={item.codeLink} demo={item.demoLink}/>
       // );
    //});
  

    return(
        <section id='work'>
        <div>
            <h3>Portfolio</h3>
            <hr style={{backgroundColor: '#f7d6c6'}}/>

            <div className="row">
            <div class="col s12 m4">
      <div class="card">
        <div class="card-image waves-effect waves-block waves-light">
          <img style={{objectFit:'contain'}} src={wedding} onClick={this.onWeddingClick.bind(this)} alt='wedding' />    
      </div>
      <div class="card-action" style={{textAlign:'center',padding:"16px 4px"}}>
          <a href="/wedding">wedding & engagement</a>
        </div>
    </div>
  </div>


            <div class="col s12 m4">
      <div class="card">
        <div class="card-image waves-effect waves-block waves-light">
          <img style={{objectFit:'contain'}} src={makeover}  onClick={this.onMakeoverClick.bind(this)} alt='makeover'/>    
      </div>
      <div class="card-action" style={{textAlign:'center',padding:"16px 4px"}}>
          <a href="/makeover">make over</a>
        </div>
    </div>
  </div>
  <div class="col s12 m4">
      <div class="card">
        <div class="card-image waves-effect waves-block waves-light">
          <img style={{objectFit:'contain'}} src={makeup} onClick={this.onMakehairClick.bind(this)} alt='makrhair'/>    
      </div>
      <div class="card-action" style={{textAlign:'center',padding:"16px 4px"}}>
          <a href="/makehair">beauty makeup & hair</a>
        </div>
    </div>
  </div>

            </div>
            <div className="row center-align">
            <a class="waves-effect waves-light btn" href='/pricing'>Check Price</a>
            </div>

            </div>
        </section>
    );
}

}

export default withRouter(Work);


// WEBPACK FOOTER //
// ./src/components/work.js